var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDzAlgeria(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_16466)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0H0V45H30V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 0H30V45H60V0Z",
    fill: "#006233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2504 16.875C21.4886 14.7303 23.4 13.0541 25.688 12.1064C27.976 11.1586 30.5128 10.9924 32.9049 11.6333C35.297 12.2743 37.4108 13.6867 38.9184 15.6514C40.426 17.6162 41.2432 20.0235 41.2432 22.5C41.2432 24.9765 40.426 27.3838 38.9184 29.3486C37.4108 31.3133 35.297 32.7257 32.9049 33.3667C30.5128 34.0076 27.976 33.8414 25.688 32.8936C23.4 31.9459 21.4886 30.2697 20.2504 28.125C21.4158 29.5806 23.0045 30.6383 24.797 31.1519C26.5895 31.6655 28.4973 31.6096 30.2567 30.9921C32.0161 30.3745 33.5403 29.2257 34.6186 27.7045C35.6968 26.1832 36.276 24.3646 36.276 22.5C36.276 20.6354 35.6968 18.8168 34.6186 17.2955C33.5403 15.7743 32.0161 14.6255 30.2567 14.0079C28.4973 13.3904 26.5895 13.3345 24.797 13.8481C23.0045 14.3617 21.4158 15.4194 20.2504 16.875ZM19.8754 22.5L30.0004 19.2L23.7004 27.825V17.175L30.0004 25.8L19.8754 22.5Z",
    fill: "#D21034"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_16466"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDzAlgeria);
export default __webpack_public_path__ + "static/media/dz Algeria.354775235e793949cba5b32ac2938cbc.svg";
export { ForwardRef as ReactComponent };